
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/content-preferences",
      function () {
        return require("private-next-pages/register/content-preferences.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/content-preferences"])
      });
    }
  